import ReportBuilder from './ReportBuilder';

export default ReportBuilder;
